import React, { useState, useEffect } from 'react'
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Grid, Pagination, Container, Card, Button, LinearProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BsJustify } from 'react-icons/bs';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';

const AddServices = ({ AllServices }) => {

    const [open, setOpen] = useState(false);
    const [serviceName, setServiceName] = useState('');
    const [servicePrice, setServicePrice] = useState('');
    const [Loading, setLoading] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleSaveChange = async () => {
        if (!serviceName) {
            return toast.error('please enter a service name');
        }
        if (!servicePrice) {
            return toast.error('please enter a service price');
        } else if (isNaN(servicePrice)) {
            return toast.error('service price should be numeric');
        }
        if (serviceName.length > 255) {
            return toast.error('only add 255 characters to service name');
        }
        try {
            setLoading(true);
            const res = await LeadService.AddServices(serviceName, servicePrice);
            if (res.data.success) {
                toast.success(res.data.message);
                AllServices();
                setServiceName('');
                setServicePrice('');

            }

        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setOpen(false);
        }

    }
    return (
        <div>
            <Button
                onClick={handleOpen}
                variant="contained"
                className='main-primary-btn'
            > <AddIcon style={{ fontSize: '18px' }} /> Add Service</Button>

            <Modal open={open} >
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                    className="modal-resp-settings"
                >
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box style={{ padding: '20px' }}>
                        <Box style={{ display: 'flex' }} className='w-100'>
                            {/* <ManageAccountsIcon /> */}
                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Service Name</Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                onChange={(event, value) => setServiceName(event.target.value)}
                                placeholder="Service Name"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>
                        <Box style={{ display: 'flex', marginTop: '10px' }}>

                            <Typography style={{
                                fontSize: '18px',
                                color: '#252F46',
                                fontWeight: '700'
                            }}>Service Price</Typography>
                        </Box>
                        <Box style={{ marginTop: '10px' }}>
                            <TextField
                                fullWidth
                                multiline
                                onChange={(event, value) => setServicePrice(event.target.value)}
                                placeholder="Service Price"
                                style={{
                                    fontSize: '10px',
                                    color: '#6E757C',
                                }}
                                // InputProps={{
                                //     style: {
                                //         height: 'auto',
                                //         width: '416px',
                                //     },
                                // }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                    },
                                }}
                            />
                        </Box>

                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={handleClose}
                                    sx={{
                                        width: {
                                            xs: '100px',
                                            sm: '120px',
                                            md: '148px'
                                        },
                                        height: '43px',
                                        backgroundColor: 'white',
                                        color: '#252F46',
                                        borderRadius: '12px',
                                        textTransform: 'capitalize',
                                        fontSize: 'auto',
                                        border: '1px solid #252F46',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        fontFamily: 'inherit', 
                                    }}
                                    
                                >  Cancel</Button>
                            </Box>

                            <Box>
                                <Button
                                    onClick={handleSaveChange}
                                    variant="contained"
                                    sx={{
                                        width: {
                                            xs: '100px',
                                            sm: '120px',
                                            md: '148px'
                                        },
                                        height: '43px',
                                        borderRadius: '12px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        border: '1px solid #587DBF',
                                        backgroundColor: '#5379BD',
                                        textTransform: 'capitalize',
                                        color: 'white',
                                        fontFamily: 'inherit'
                                    }}
                                    
                                    disabled={Loading} // Disable the button when loading
                                >
                                    {Loading ? 'Saving...' : 'Save'} {/* Optional: Show loading text */}
                                </Button>
                                <LinearProgress sx={{ visibility: Loading ? '' : 'hidden' }} />
                            </Box>

                        </Box>
                    </Box>


                </Box>
            </Modal>

        </div>
    )
}

export default AddServices
